<template>
  <div class="cps-main-page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item><i class="el-icon-s-home"></i>首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>游戏喊话记录</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>
    <div class="page-content">
      <el-row @keyup.enter.native="loadData(1)">
        <el-input v-model.trim="query.cardNo" size="small" placeholder="身份证号码"></el-input>
        <el-input v-model.trim="query.realname" size="small" placeholder="姓名"></el-input>
        <el-button type="primary" size="small" @click="loadData(1)">查询</el-button>
      </el-row>
      <el-table
          class="cps-table-data"
          :data="tableData"
          size="small"
          border
          :height="height"
          style="width: 100%">
        <el-table-column
            prop="id"
            label="id"
            width="90">
        </el-table-column>
        <el-table-column
            prop="card_no"
            label="身份证号码"
            width="200">
        </el-table-column>
        <el-table-column
            prop="realname"
            label="真实姓名"
            width="120">
        </el-table-column>
        <el-table-column
            prop="check_time"
            label="时间"
            width="200">
        </el-table-column>
        <el-table-column
            width="280"
            label="操作">
          <template v-slot="scope">
            <el-button v-if="showDel" @click="delRecord(scope.row.id)" type="text" size="small">删除记录</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          class="cps-table-data"
          @current-change="loadData"
          background
          :page-size="15"
          :current-page="currentIndex"
          layout="total,prev, pager, next"
          :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {deleteAutonymRecord, getPageButtons, queryBlacklist} from "@/api/request";

export default {
  name: "blacklist",
  data(){
    return {
      tableData:[],
      height: window.innerHeight - 220,
      currentIndex: 1,
      total: 0,
      query:{
        cardNo: "",
        realname: ""
      },
      showDel: false
    }
  },
  mounted() {
    this.loadData(1);
    this.getPageButtons();
  },
  methods: {
    loadData(index){
      let params = {
        pageNo: index,
        pageSize: 15,
        params: this.query
      }
      queryBlacklist(params).then(res => {
        this.tableData = res.data.list;
        this.currentIndex = index;
        this.total = res.data.total;
      })
    },
    delRecord(id){
      this.$confirm('此操作将永久删除该记录, 是否继续?','提示',{
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: "warning"
      }).then(() => {
        console.log(1)
        deleteAutonymRecord(id).then(res => {
          console.log(res)
          if(res.data.success){
            this.$message.success("删除成功")
            this.loadData(this.currentIndex)
          }else {
            this.$message.error(res.data.error.message);
          }
        });
      }).catch(() => {
        this.$message.info("已取消删除");
      })
    },
    getPageButtons() {
      let path = this.$route.path.replace("/", "");
      getPageButtons(path).then((res) => {
        if (res.data.success) {
          let menuCodes = res.data.data;
          this.showDel = menuCodes.includes("blacklist_del");
        } else {
          this.$message.error(res.data.error.message);
        }
      });
    },
  }
}
</script>

<style scoped>

</style>